import React from 'react'
import { Link } from "gatsby"
import Layout from "../components/Layout"
import About from '../components/Home/About'
import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"

export default function about({data}) {
    return ( 
        <Layout>
   
      <About/>
    </Layout>
    )
}
{/* <StyledHero img={data.contactBcg.childImageSharp.fluid}/> */}
export const query = graphql`
  query {
    contactBcg: file(relativePath: { eq: "aboutusBcg.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
